import React, { useEffect, useState } from "react";
import { Modal, Box, Typography, Button, Stack, Divider, Paper, IconButton, Alert, Chip, CircularProgress } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes, faDownload, faCheckDouble, faClock, faPen, faArrowLeft, faExclamationTriangle, faCheckCircle } from "@fortawesome/free-solid-svg-icons";
import { Firma } from './Firma';
import { useForm } from "../../hooks/useForm";
import { OtecServices } from '../../controllers/services/otec.services'
import { OtecAdapters } from '../../controllers/adapters/otec.adapters'
import { ModalStatusServerOtec } from '../../components/ModalStatus/ModalStatusServerOtec';

export const PdfModal = ({ data, solicitudState, setSolicitudState, fetchDatosPersonales }:any) => {
  const [open, setOpen] = useState(false);
  const [pdfState, setPdfState] = useState<any>(null);
  const [pdfUrl, setPdfUrl] = useState(null);
  const [pdfFechaFirma, setPdfFechaFirma] = useState(null);

  /*Datos pki firma*/
  const [pki, setPki] = useState<any>()
  const [certificates, setCertificates] = useState<any>([])
  const [readyPKI, setreadyPKI] = useState(false)

  const { fetchData: fetchPreFirmarPdf, data: datosPreFirmaPdf, loading: loadingPreFirmaPdf, error: errorPreFirmaPdf, resetState:resetStatePreFirmar } = OtecServices.POST_PRE_FIRMAR_DOCUMENTO();

  const { fetchData: fetchFirmarPdf, data: datosFirmaPdf, loading: loadingFirmaPdf, error: errorFirmaPdf} = OtecServices.POST_FIRMAR_DOCUMENTO();

  const [formDatosFirma, handleInputDatosFirma, handleFormDatosFirma, handleResetFormDatosFirma] = useForm({
    ...OtecAdapters.POST_FIRMAR_DOCUMENTO.send.schema({})
  })

  useEffect(() => {
    if (data?.pdf) {
      setPdfUrl(data.pdf.url_pdf);
      setPdfFechaFirma(data.pdf.fecha_firma);
      setOpen(true);
    }
  }, [data]);

  const handleClose = () => setOpen(false);

  const handlePreFirmar = (e:any) => {
    e.preventDefault();
    pki.readCertificate(formDatosFirma.certificado)
      .success(function (certificate:any) {
          fetchPreFirmarPdf({
            body: {
              certificado:certificate,
              accion: 'pre_firmar_pdf',
              solicitud_id: data?.id,
            }
        })
      }).fail(function (e:any) {
          console.error(e.responseJSON?.message);
      })
  };

  const handleDescargar = () => {
    if (pdfUrl) {
      window.open(pdfUrl, "_blank");
    } else {
      alert("No se encontró la URL del PDF.");
    }
  };

  useEffect(() => {
    if(datosFirmaPdf?.data){
      setPdfUrl(datosFirmaPdf.data.url_pdf);
      setPdfFechaFirma(datosFirmaPdf.data.fecha_firma);
      //setSolicitudState(datosFirmaPdf.data.estado);
      fetchDatosPersonales({
        body: {
          accion: 'obtener_datos'
        }
      })
    }
  },[datosFirmaPdf])

  useEffect(() => {
      if (datosPreFirmaPdf?.data) {
          pki.signHash({
              thumbprint: formDatosFirma.certificado,
              hash: datosPreFirmaPdf.data?.dataToSignBase64,
              digestAlgorithm: datosPreFirmaPdf.data?.digestAlgorithmOid
          }).success(function (signature:any) {
              fetchFirmarPdf({
                  body: {
                    accion: 'firmar_pdf',
                    signature: signature,
                    solicitud_id: data?.id,
                  }
              })
          }).fail(function (e:any) {
              console.error(e.responseJSON?.message);
          })
      }
    }, [datosPreFirmaPdf])


  return (
    <>
    <Modal 
      open={open} 
      onClose={handleClose}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backdropFilter: 'blur(2px)',
        outline: "none",
      }}
    >
      <Paper 
        elevation={24}
        sx={{
          width: '80%',
          maxWidth: 800,
          maxHeight: '90vh',
          overflow: 'auto',
          borderRadius: 2,
          p: 3,
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
          <Typography variant="h5" fontWeight="bold">
            Signar Document Sol·licitud ETEC
          </Typography>
          <IconButton 
            onClick={handleClose} 
            sx={{ color: 'text.secondary' }}
          >
          <FontAwesomeIcon icon={faTimes} />
          </IconButton>
        </Box>
        
        <Divider sx={{ mb: 3 }} />
        <Box mb={3}>
          {solicitudState === "pendiente_verificacion" ? (
              <Alert 
                icon={<FontAwesomeIcon icon={faCheckDouble} />}
                severity="info"
                sx={{ alignItems: 'center' }}
              >
                <Box sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
                  <Typography variant="body1" sx={{ fontWeight: 'medium', mr: 1 }}>
                    Document pendent de verificació
                  </Typography>
                  <Chip 
                    label="Verificación"
                    size="small"
                    color="info"
                    variant="outlined"
                    sx={{ ml: 1 }}
                  />
                </Box>
                <Typography variant="body2" sx={{ mt: 0.5 }}>
                  El vostre document serà verificat per un administrador i rebrà una notificació al correu registrat
                </Typography>
              </Alert>
            ) : solicitudState === "activo" ? (
                <Alert 
                  icon={<FontAwesomeIcon icon={faCheckDouble} />}
                  severity="success"
                  sx={{ alignItems: 'center' }}
                >
                  <Box sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
                    <Typography variant="body1" sx={{ fontWeight: 'medium', mr: 1 }}>
                      Document signat digitalment
                    </Typography>
                    <Chip 
                      label="Válido y verificado"
                      size="small"
                      color="success"
                      variant="outlined"
                      sx={{ ml: 1 }}
                    />
                  </Box>
                  <Typography variant="body2" sx={{ mt: 0.5 }}>
                    Signatura realitzada el {pdfFechaFirma}
                  </Typography>
                </Alert>
              ) : (
              <Alert 
                icon={<FontAwesomeIcon icon={faClock} />}
                severity="warning"
                sx={{ alignItems: 'center' }}
              >
                <Box sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
                  <Typography variant="body1" sx={{ fontWeight: 'medium', mr: 1 }}>
                    Pendent de signatura digital
                  </Typography>
                  <Chip 
                    label="No firmado"
                    size="small"
                    color="warning"
                    variant="outlined"
                    sx={{ ml: 1 }}
                  />
                </Box>
                <Typography variant="body2" sx={{ mt: 0.5 }}>
                  Aquest document requereix signatura digital per ser vàlid
                </Typography>
              </Alert>
            )}
        </Box>
        
        {solicitudState === "pendiente_firma" && (
          <Box mb={3}>
            <Firma
              formDatosFirma={formDatosFirma} 
              handleInputDatosFirma={handleInputDatosFirma}
              pki={pki}
              setPki={setPki}
              certificates={certificates}
              setCertificates={setCertificates}
              readyPKI={readyPKI}
              setreadyPKI={setreadyPKI}
            />
          </Box>
        )}
        
        <Box
          sx={{
            flexGrow: 1,
            borderRadius: 1,
            mb: 3,
            height: 600,
            backgroundColor: "#f9f9f9",
            overflow: "hidden",
          }}
        >
          {pdfUrl ? (
            <iframe
              src={`${pdfUrl}#toolbar=0&navpanes=0&scrollbar=0`}
              width="100%"
              height="100%"
              style={{
                border: "none",
                borderRadius: "8px",
                display: "block",
              }}
              title="Vista previa del PDF"
            />
          ) : (
            <Box
              sx={{
                height: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Typography variant="body2" color="text.secondary">
                Vista prèvia del document PDF
              </Typography>
            </Box>
          )}
        </Box>

        <Box mt="auto" display="flex" flexDirection="column" gap={3}>
          <Stack direction="row" spacing={2} justifyContent="center">
            <Button
              variant="outlined"
              startIcon={<FontAwesomeIcon icon={faDownload} />}
              onClick={handleDescargar}
            >
              Descarregar PDF
            </Button>

            {solicitudState === "pendiente_firma" && (
              <Button
                variant="contained"
                color="success"
                startIcon={(loadingPreFirmaPdf || loadingFirmaPdf) ? <CircularProgress size={20} thickness={4} color="inherit" /> : <FontAwesomeIcon icon={faPen} />}
                onClick={handlePreFirmar}
                disabled={(loadingPreFirmaPdf || loadingFirmaPdf) || !formDatosFirma.certificado}
              >
                Signar document
              </Button>
            )}
          </Stack>

          <Stack direction="row" spacing={2} justifyContent="flex-end">
            <Button
              variant="outlined"
              startIcon={<FontAwesomeIcon icon={faTimes} />}
              onClick={handleClose}
            >
              Tancar
            </Button>
          </Stack>
        </Box>
      </Paper>
    </Modal>

    <ModalStatusServerOtec
        fetchData={{ data: datosPreFirmaPdf, loading: loadingPreFirmaPdf, error: errorPreFirmaPdf}}
        activeLoading
        disableStatus
        resetState={resetStatePreFirmar}
      />
    </>
  );
}
